import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import * as _ from 'lodash';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class CurrencyExchangeService {
  private exchangeRateCache: Array<CurrencyExchangeRateCache> = [];

  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient) { }

  public convert(sourceCurrency: string, destinationCurrency: string, amount: number): Observable<number> {
    const exchangeRate = this.exchangeRateCache.find((exchangeRateCache) => exchangeRateCache.sourceCurrency === sourceCurrency &&
      exchangeRateCache.destinationCurrency === destinationCurrency);

    if (!_.isNil(exchangeRate)) {
      return of(amount * exchangeRate.rate);
    } else {
      return this.http.post<number>(`${this.appConfigService.getConfig().apiUrl}currencyexchange/convert`, { sourceCurrency, destinationCurrency }).pipe(map((result: number) => {
        this.exchangeRateCache.push({
          sourceCurrency,
          destinationCurrency,
          rate: result
        });

        return amount * result;
      }));
    }
  }
}

export class CurrencyExchangeRateCache {
  constructor() {
    this.sourceCurrency = '';
    this.destinationCurrency = '';
    this.rate = 0;
  }

  sourceCurrency: string;
  destinationCurrency: string;
  rate: number;
}
